// src/opsgenie/saved-search/types.ts
var OpsgenieSavedSearchAriResourceOwner = "opsgenie", OpsgenieSavedSearchAriResourceType = "saved-search";

export {
  OpsgenieSavedSearchAriResourceOwner,
  OpsgenieSavedSearchAriResourceType
};
